import { NgModule } from '@angular/core';

// Composants graphiques utilises

// Module metier utilises

// Modules Material utilises

// Autres modules externes utilises 

// Modules communs utilises

// Composants metiers

// Services metier
import { OperationService } from './services/operation.service';
import { OperationEntrepriseService } from './services/operation-entreprise.service';

// Pipes

// Bridges avec la partie angular

@NgModule({
	imports: [
	],
	providers: [
		OperationService,
		OperationEntrepriseService,
	],
	declarations: [
	],
	exports: [
	]
})
export class OperationModule {
	constructor() { }
}